import React, { useState } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";

import cnIcon1 from "../../../images/icons/angular.png";
import cnIcon2 from "../../../images/icons/vuejs (1).svg";
import cnIcon3 from "../../../images/icons/next.png";
import cnIcon4 from "../../../images/icons/icon_python.svg";
import cnIcon5 from "../../../images/icons/mysql.svg";
import cnIcon7 from "../../../images/icons/mongodb.svg";
import cnIcon8 from "../../../images/icons/sql.png";
import cnIcon9 from "../../../images/icons/nosql.png";
import cnIcon10 from "../../../images/icons/firebase2.png";
import cnIcon11 from "../../../images/icons/Postgresql2.png";
import cnIcon12 from "../../../images/icons/aws.png";
import cnIcon13 from "../../../images/icons/azure.png";
import cnIcon14 from "../../../images/icons/googlecloud.png";
import cnIcon15 from "../../../images/icons/docker.png";
import cnIcon16 from "../../../images/icons/Kubernetes-Logo.png";
import cnIcon17 from "../../../images/icons/Jenkins.png";
import cnIcon18 from "../../../images/icons/gitlab.png";
import cnIcon19 from "../../../images/icons/apache-logo.png";
import cnIcon20 from "../../../images/icons/cloudflare.png";
import cnIcon21 from "../../../images/icons/tls.png";
import cnIcon22 from "../../../images/icons/aws.png";
import cnIcon23 from "../../../images/icons/azure.png";
import cnIcon24 from "../../../images/icons/Flutter.png";
import cnIcon25 from "../../../images/icons/react.png";
import cnIcon26 from "../../../images/icons/swift.png";
import cnIcon27 from "../../../images/icons/java.svg";
import cnIcon28 from "../../../images/icons/Kotlin.png";
import cnIcon29 from "../../../images/icons/bubble.png";
import cnIcon30 from "../../../images/icons/flask.png";
import cnIcon31 from "../../../images/icons/powerbi.png";
import cnIcon32 from "../../../images/icons/ruby-icon.png";
import cnIcon33 from "../../../images/icons/c++.jpg";
import cnIcon34 from "../../../images/icons/net mui.png";
import cnIcon35 from "../../../images/icons/NumPy.webp";
import cnIcon36 from "../../../images/icons/icon_php.svg";
import cnIcon37 from "../../../images/icons/icon_javascript.svg";
import cnIcon38 from "../../../images/icons/icon_typescript.svg";
import cnIcon39 from "../../../images/icons/icon_react_js.svg";
import cnIcon40 from "../../../images/icons/icon_laravel.svg";





import Bg from "../../../images/shapes/shape_title_under_line.svg";

const WebPlatForms = [
  {
    Id: "1",
    sIcon: cnIcon1,
    title: "Angular",
  },
  {
    Id: "2",
    sIcon: cnIcon2,
    title: "Vue Js",
  },
  {
    Id: "3",
    sIcon: cnIcon3,
    title: "Next",
  },
  {
    Id: "4",
    sIcon: cnIcon4,
    title: "Python",
  },
  {
    Id: "4",
    sIcon: cnIcon36,
    title: "PHP",
  },
  {
    Id: "4",
    sIcon: cnIcon37,
    title: "JavaScript",
  },
  {
    Id: "4",
    sIcon: cnIcon38,
    title: "TypeScript",
  },
  {
    Id: "4",
    sIcon: cnIcon39,
    title: "react",
  },
  {
    Id: "4",
    sIcon: cnIcon40,
    title: "Laravel",
  },
];
const Databases = [
  { Id: "1", sIcon: cnIcon5, title: "MySQL" },
  { Id: "2", sIcon: cnIcon7, title: "MongoDB" },
  { Id: "3", sIcon: cnIcon8, title: "SQL" },
  { Id: "4", sIcon: cnIcon9, title: "NoSQL" },
  { Id: "5", sIcon: cnIcon10, title: "Firebase" },
  { Id: "6", sIcon: cnIcon11, title: "PostgreSQL" },
];
const CloudDevOps = [
  { Id: "1", sIcon: cnIcon12, title: "AWS" },
  { Id: "2", sIcon: cnIcon13, title: "Azure" },
  { Id: "3", sIcon: cnIcon14, title: "Google Cloud" },
  { Id: "4", sIcon: cnIcon15, title: "Docker" },
  { Id: "5", sIcon: cnIcon16, title: "Kubernetes" },
  { Id: "6", sIcon: cnIcon17, title: "Jenkins" },
  { Id: "7", sIcon: cnIcon18, title: "GitLab" },
  { Id: "8", sIcon: cnIcon19, title: "Apache" },
  { Id: "9", sIcon: cnIcon20, title: "Cloudflare" },
  { Id: "10", sIcon: cnIcon21, title: "TLS" },
  { Id: "11", sIcon: cnIcon22, title: "AWS" },
  { Id: "12", sIcon: cnIcon23, title: "Azure" },
];
const MobileApps = [
  { Id: "1", sIcon: cnIcon24, title: "Flutter" },
  { Id: "2", sIcon: cnIcon25, title: "React" },
  { Id: "3", sIcon: cnIcon26, title: "Swift" },
  { Id: "4", sIcon: cnIcon27, title: "Java" },
  { Id: "5", sIcon: cnIcon28, title: "Kotlin" },
];
const OtherFrameworks = [
  { Id: "1", sIcon: cnIcon29, title: "Bubble" },
  { Id: "2", sIcon: cnIcon30, title: "Flask" },
  { Id: "3", sIcon: cnIcon31, title: "PowerBI" },
  { Id: "4", sIcon: cnIcon32, title: "Ruby" },
  { Id: "5", sIcon: cnIcon33, title: "C++" },
  { Id: "6", sIcon: cnIcon34, title: ".Net MAUI" },
  { Id: "7", sIcon: cnIcon35, title: "NumPy" },
];

const TechnologySection = (props) => {
  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="section_space">
      <div className="heading_block text-center">
        <div
          className="heading_focus_text has_underline d-inline-flex"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          Our Technologies
        </div>
        <h2 className="heading_text mb-0">
          We Use <mark>Technologies</mark>
        </h2>
      </div>

      <div className="tab_block_wrapper">
        <Nav tabs className="nav justify-content-center">
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "1" })}
              onClick={() => {
                toggle("1");
              }}
            >
              Web Platform
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "2" })}
              onClick={() => {
                toggle("2");
              }}
            >
              Databases
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "3" })}
              onClick={() => {
                toggle("3");
              }}
            >
              Cloud & DevOps
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "4" })}
              onClick={() => {
                toggle("4");
              }}
            >
              Mobile Apps
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "5" })}
              onClick={() => {
                toggle("5");
              }}
            >
              Other Frameworks
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <div className="web_development_technologies row justify-content-center">
              {WebPlatForms.map((technology, cnt) => (
                <div className="col-lg-3 col-md-3 col-sm-4 col-6" key={cnt}>
                  <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                    <div className="iconbox_icon">
                      <img src={technology.sIcon} alt="" />
                    </div>
                    <div className="iconbox_content">
                      <h3 className="iconbox_title mb-0">{technology.title}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </TabPane>
          <TabPane tabId="2">
            <div className="web_development_technologies row justify-content-center">
              {Databases.map((technology, cnt) => (
                <div className="col-lg-3 col-md-3 col-sm-4 col-6" key={cnt}>
                  <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                    <div className="iconbox_icon">
                      <img src={technology.sIcon} alt="" />
                    </div>
                    <div className="iconbox_content">
                      <h3 className="iconbox_title mb-0">{technology.title}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </TabPane>
          <TabPane tabId="3">
            <div className="web_development_technologies row justify-content-center">
              {CloudDevOps.map((technology, cnt) => (
                <div className="col-lg-3 col-md-3 col-sm-4 col-6" key={cnt}>
                  <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                    <div className="iconbox_icon">
                      <img src={technology.sIcon} alt="" />
                    </div>
                    <div className="iconbox_content">
                      <h3 className="iconbox_title mb-0">{technology.title}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </TabPane>
          <TabPane tabId="4">
            <div className="web_development_technologies row justify-content-center">
              {MobileApps.map((technology, cnt) => (
                <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={cnt}>
                  <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                    <div className="iconbox_icon">
                      <img src={technology.sIcon} alt="" />
                    </div>
                    <div className="iconbox_content">
                      <h3 className="iconbox_title mb-0">{technology.title}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </TabPane>
          <TabPane tabId="5">
            <div className="web_development_technologies row justify-content-center">
              {OtherFrameworks.map((technology, cnt) => (
                <div className="col-lg-3 col-md-3 col-sm-4 col-6" key={cnt}>
                  <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                    <div className="iconbox_icon">
                      <img src={technology.sIcon} alt="" />
                    </div>
                    <div className="iconbox_content">
                      <h3 className="iconbox_title mb-0">{technology.title}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
};

export default TechnologySection;
